// src/components/UserSearchInput.js
import React, { useState, useEffect, useRef } from 'react';
import Avatar from './Avatar';

export default function UserSearchInput({ users, onUserSelect, placeholder = "Начните вводить никнейм..." }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  
  // --- НОВОЕ: Храним не просто ID, а весь объект выбранного пользователя ---
  const [selectedUser, setSelectedUser] = useState(null);
  
  const inputRef = useRef(null); // Ссылка на input-элемент

  useEffect(() => {
    if (searchTerm && !selectedUser) { // Поиск работает только если никто не выбран
      const filtered = users.filter(user =>
        (user.username && user.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (user.serverNickname && user.serverNickname.toLowerCase().includes(searchTerm.toLowerCase()))
      ).slice(0, 5);
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  }, [searchTerm, users, selectedUser]);

  const handleSelect = (user) => {
    setSelectedUser(user); // Сохраняем весь объект
    onUserSelect(user.id); // Отдаем ID родителю
    setSearchTerm('');     // Очищаем поиск
    setSuggestions([]);
    inputRef.current.blur(); // Снимаем фокус с инпута
  };

  const handleChange = (e) => {
    // Если пользователь что-то печатает, сбрасываем предыдущий выбор
    if (selectedUser) {
      setSelectedUser(null);
      onUserSelect('');
    }
    setSearchTerm(e.target.value);
  };
  
  // --- НОВАЯ ЛОГИКА: Проверка, совпадает ли введенный текст с кем-то из списка ---
  const isSelectionRequired = searchTerm && suggestions.length > 0 && !selectedUser;

  return (
    <div className="user-search-container" onBlur={() => setTimeout(() => setIsFocused(false), 200)}>
      <div className={`user-search-input-wrapper ${isSelectionRequired ? 'warning' : ''}`}>
        {/* --- НОВОЕ: Отображение аватарки выбранного пользователя --- */}
        {selectedUser && (
          <Avatar user={selectedUser} className="avatar-in-input" />
        )}
        <input
          ref={inputRef}
          type="text"
          // --- ИЗМЕНЕНИЕ: Показываем имя выбранного пользователя или поисковый запрос ---
          value={selectedUser ? (selectedUser.serverNickname || selectedUser.username) : searchTerm}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          placeholder={placeholder}
          autoComplete="off"
        />
        {/* --- НОВОЕ: Кнопка сброса выбора --- */}
        {selectedUser && (
             <button type="button" className="clear-selection-btn" onClick={() => handleChange({ target: { value: '' } })}>
                 &times;
             </button>
        )}
      </div>
      {isFocused && suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map(user => (
            <li key={user.id} onMouseDown={() => handleSelect(user)}>
              <Avatar user={user} className="avatar-small" />
              <span>{user.serverNickname || user.username}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}